import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'

import content from '../data/content'
import Input from './Input'
import Img from './Img'

const Newsletter = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT || ''
  const location = useLocation()

  const [isChecked, setIsChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const baseFormData = {
    type: content?.menuPrimary?.href?.includes(location.pathname)
      ? 'pro'
      : 'particulier',
    baseurl: 'https://distriboissons.be',
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const formDataObj = new FormData(e.target)
    const formValues = Object.fromEntries(formDataObj.entries())

    const payload = {
      ...baseFormData,
      ...formValues,
    }

    setLoading(true)
    setError(null)

    try {
      const response = await fetch(`${environment}/data/newsletter.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })

      const result = await response.json()

      if (result.status === 'ok') {
        setSuccess(true)
      } else {
        setError(result.status || 'Erreur serveur')
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue')
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="mt-8 w-full text-center color_light">
        Inscription réussie !
      </div>
    )
  }

  return (
    <>
      <form
        className="relative mb-4 max-w-full text-center newsletter"
        onSubmit={handleSubmit}
      >
        <Img classe="m-auto w-[48px]" blockKey="mail" />

        <h3 className="mb-2 text-2xl font-bold md:text-4xl">
          Inscrivez-vous à notre newsletter
        </h3>

        <Input id="mail_subscribe" label="E-Mail" type="email" required />

        <input type="hidden" value={baseFormData.type} name="type" />
        <input type="hidden" value={baseFormData.baseurl} name="baseurl" />

        <div className="w-full mt-4 mb-4">
          <input
            type="checkbox"
            id="checkbox"
            required
            onChange={(e) => setIsChecked(e.target.checked)}
            checked={isChecked}
          />
          <label className="checkbox color_light" htmlFor="checkbox">
            J’aimerais recevoir des communications marketing par e-mail.
          </label>
        </div>

        <button
          disabled={!isChecked || loading}
          className="button"
          type="submit"
        >
          {loading ? 'Envoi...' : 'Envoyer'}
        </button>
      </form>

      <div className="mt-4 text-center">
        {error && <div>Error: {error}</div>}
      </div>
    </>
  )
}

export default Newsletter
